export default {
    namespaced: true,

    state: {
        total: null,
        outstandingAmount: null,
        outstandingCharges: null,
        paidAmount: null,
    },

    getters: {
        outstandingAmountFormatted: (state) => {
            if(state.outstandingAmount) {
                return parseFloat(state.outstandingAmount.AmountOS);
            }
        },
        totalAmountFormatted: (state) => {
            if(state.total) {
                return (parseFloat(state.total.ChargeTotal) + parseFloat(state.total.VatTotal));
            }
        },
    },

    actions: {
        reset({ commit }) {
            commit('setOutstandingAmount', null);
            commit('setOutstandingCharges', null);
            commit('setPaidAmount', null);
            commit('setTotal', null);
        },
        getOutstandingAmount({ commit }, tenancyPK) {
            return axios.get(`/api/contacts/tenancies/${tenancyPK}/charges/outstanding`)
            .then((response) => {
                commit('setOutstandingAmount', response.data.data);
            })
            .catch(() => {
                commit('setOutstandingAmount', null);
            });
        },
        getOutstandingCharges({ commit }, tenancyPK) {
            return axios.get(`/api/contacts/tenancies/${tenancyPK}/charges`)
            .then((response) => {
                commit('setOutstandingCharges', response.data.data);
            })
            .catch(() => {
                commit('setOutstandingCharges', null);
            });
        },
        getPaidAmount({ commit }, tenancyPK) {
            return axios.get(`/api/contacts/tenancies/${tenancyPK}/charges/paid`)
            .then((response) => {
                commit('setPaidAmount', response.data.data);
            })
            .catch(() => {
                commit('setPaidAmount', null);
            });
        },
        getTotal({ commit }, tenancyPK) {
            return axios.get(`/api/contacts/tenancies/${tenancyPK}/charges/total`)
            .then((response) => {
                commit('setTotal', response.data.data);
            })
            .catch(() => {
                commit('setTotal', null);
            });
        },
    },

    mutations: {
        setOutstandingAmount(state, outstandingAmount) {
            state.outstandingAmount = outstandingAmount;
        },
        setOutstandingCharges(state, outstandingCharges) {
            state.outstandingCharges = outstandingCharges;
        },
        setPaidAmount(state, paidAmount) {
            state.paidAmount = paidAmount;
        },
        setTotal(state, total) {
            state.total = total;
        },
    },
};
